import http from './http';

/**
 * Obtiene los datos del dashboard.
 */
export async function getDashboardData(params = {}) {
    const res = await http.get('/dashboard', {
        params,
        paramsSerializer: {
            serialize: (params) => {
                const searchParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(v => searchParams.append(key, v));
                    } else if (value !== undefined && value !== null) {
                        searchParams.append(key, value);
                    }
                });
                return searchParams.toString();
            }
        }
    });
    return res.data?.data ?? res.data;
}

/**
 * Exporta el reporte del dashboard en formato Excel.
 */
export async function exportDashboardReport(params = {}) {
    const res = await http.get('/dashboard/export', {
        params,
        responseType: 'blob',
        paramsSerializer: {
            serialize: (params) => {
                const searchParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(v => searchParams.append(key, v));
                    } else if (value !== undefined && value !== null) {
                        searchParams.append(key, value);
                    }
                });
                return searchParams.toString();
            }
        }
    });
    return res.data;
}
